import React, {Component} from 'react'
import { Link } from 'react-router-dom'
import { FaRegEdit, FaTrashAlt } from "react-icons/fa";
import { Button } from 'react-bootstrap';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

class ListTicketRowComponent extends Component {

    loadStatus = (status) => {
        if ( status === 'Pending' ) {
            return (
                <span className="text-warning">
                    Đang chờ xử lý
                </span>
            )
        }
        else if (status === 'Done') {
            return (
                <span className="text-success">
                    Đã xử lý xong
                </span>
            );
        }
        else if (status === 'Processing') {
            return (
                <span className="text-info">
                    Đang xử lý
                </span>
            );
        }
        else if (status === 'Cancel') {
            return (
                <span className="text-danger">
                    Đã hủy
                </span>
            );
        }
    }

    checkedTicket = (e) => {
        if ( e.nativeEvent.shiftKey ) {
            let value = e.target.checked;
            this.props.checkedTicketShiftKey( this.props.actionKey, value );
        } else {
            this.props.checkedTicket( this.props.actionKey );
        }
    }

	render() {
		return (
			<tr>
				<td className="text-center">
                    <input 
                    	type="checkbox" 
                    	checked={this.props.ticket.checked}  
                    	onChange={ this.checkedTicket } 
                    />
                </td>
				<td>#{ this.props.ticket.id }</td>
				<td><Link to={'/admin/khach-hang/chi-tiet-khach-hang/' + this.props.ticket.user_id }>{ this.props.ticket.user_name }</Link></td>
				<td>{ this.props.ticket.title }</td>
				<td>{ this.props.ticket.content }</td>
				<td>{ this.loadStatus(this.props.ticket.status) }</td>
				<td>{ this.props.ticket.dateCreated }</td> 
				<td>
					<OverlayTrigger
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Chi tiết
                            </Tooltip>
                        )}
                        placement="top"
                    >
						<Link 
							className="btn btn-warning btn-sm m-1"
							to={'/admin/ticket/detail/' + this.props.ticket.id }

						>
							<FaRegEdit />
						</Link>
					</OverlayTrigger>

					<OverlayTrigger
                        overlay={(props) => (
                            <Tooltip {...props}>
                                Xóa
                            </Tooltip>
                        )}
                        placement="top"
                    >
						<Button 
	    					className="btn btn-danger btn-sm m-1"
							onClick={ () => this.props.delete(this.props.ticket.id) }
						>
							<FaTrashAlt />
					  	</Button>
				  	</OverlayTrigger>
				</td>
			</tr>
		)
	}
}

export default ListTicketRowComponent;